"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colors = require("../colors.config");
var _fontPloni = require("../font.ploni.config");
var _helpers = require("../../components/utils/helpers");
var Contact24 = (0, _helpers.getImageByAgent)('24-7.svg');
var Coffee = (0, _helpers.getImageByAgent)('coffee.svg');
var Alert = (0, _helpers.getImageByAgent)('alert.svg');
var _default = function _default(isFontBigger) {
  return {
    '& .alert': {
      backgroundImage: "url(".concat(Alert, ")"),
      display: 'inline-flex',
      height: '71px',
      margin: '51px 100px 0px 94px',
      width: '79px'
    },
    '& .coffee': {
      backgroundImage: "url(".concat(Coffee, ")"),
      display: 'inline-flex',
      height: '107px',
      margin: '68px 95px 0px 95px',
      width: '85px'
    },
    '& .contact24': {
      backgroundImage: "url(".concat(Contact24, ")"),
      display: 'inline-flex',
      height: '45px',
      margin: '53px 0 20px 122px',
      width: '125px'
    },
    '& .MuiButton-label': {
      height: '18px'
    },
    '& .MuiButton-outlined': {
      fontFamily: _fontPloni.PloniRegular,
      fontSize: isFontBigger ? '21px' : '18px',
      fontWeight: 'bold',
      height: '52px',
      width: '100%'
    },
    '& .MuiFormControl-root.MuiTextField-root': {
      '& .MuiFormHelperText-root': {
        margin: '0 14px 0'
      },
      width: '100%'
    },
    '& .MuiGrid-item': {
      marginBottom: 6,
      padding: '0 19px 0 15px'
    },
    '& .MuiGrid-root.MuiGrid-container': {
      '& .MuiOutlinedInput-input': {
        fontWeight: 'bold'
      }
    },
    '& div.error-header': {
      color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
      display: 'inline-flex',
      fontFamily: _fontPloni.PloniRegular,
      fontSize: isFontBigger ? '28px' : '26px',
      fontWeight: 'bold',
      height: '33px',
      margin: '17px 0 10px 0',
      opacity: '1'
    },
    '& div.error-text': {
      display: 'inline-flex',
      fontFamily: _fontPloni.PloniRegular,
      fontSize: isFontBigger ? '15px' : '12px',
      height: '52px',
      letterSpacing: '0.5px',
      margin: '0 50px 10px 49px',
      opacity: '1'
    },
    '& div.label-popup': {
      color: _colors.Black[280],
      display: 'inline-flex',
      fontFamily: _fontPloni.PloniRegular,
      fontSize: isFontBigger ? '16px' : '14px',
      fontWeight: 'bold',
      height: '26px',
      margin: '0 0 0 16px',
      opacity: '1'
    },
    '& div.p-circle': {
      background: '#C0D9E3 0% 0% no-repeat padding-box',
      borderRadius: '5px',
      display: 'inline-flex',
      height: '10px',
      opacity: '1',
      width: '10px'
    },
    '& div.success-header': {
      color: _helpers.agentDeveloperUtils.getSecondaryColor(300),
      display: 'inline-flex',
      fontFamily: _fontPloni.PloniRegular,
      fontSize: isFontBigger ? '28px' : '26px',
      fontWeight: 'bold',
      height: '33px',
      margin: '15px 0 4px 0',
      opacity: '1'
    },
    '& div.success-text': {
      display: 'inline-flex',
      fontFamily: _fontPloni.PloniRegular,
      fontSize: isFontBigger ? '16px' : '14px',
      height: '24px',
      margin: '0 0 57px 0',
      opacity: '1'
    },
    '& p.p-radio': {
      color: _colors.Black[300],
      fontSize: isFontBigger ? '15px' : '12px',
      letterSpacing: 0,
      margin: '2px 0 15px 26px',
      opacity: '0.64'
    },
    border: "1px solid ".concat(_colors.Black[90]),
    borderRadius: '20px',
    boxShadow: 'none',
    width: '274px'
  };
};
exports.default = _default;